import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { domain } from "config.js";
import style from "./style.module.scss";

function News() {
    const location = useLocation();
    const locationState = location.state;

    const [data, setData] = useState(locationState);
    useEffect(()=>{
        if (!data){
            fetch("/text/news.json").then(response=>{
                response.json().then(json=>{
                    let pathString = location.pathname;
                    pathString = pathString.substr(pathString.lastIndexOf("/") + 1);
                    console.log(json, "PATH NAME", pathString);
                    setData(json[pathString]);
                })
            })
        }
    }, []);

    return (    
        <div className={style.newsRoot}>
            <div className={style.newsContainer}>
                <div className={style.date}>{data?.date}</div>
                <div className={style.title}>{data?.title}</div>

                <img src={data?.image} alt="news"/>
                <br/>
                <br/>
                <div className={style.subtitle}> {data?.subtitle} </div>
                <div className={style.text}> {data?.text} </div>
                
                <div className={style.subtitle}> {data?.subtitle} </div>
                <div className={style.text}>
                    {data?.text}
                    <ul>
                        <li>One</li>
                        <li>Two</li>
                        <li>Three</li>
                    </ul>
                </div>

                <div className={style.subtitle} style={{textTransform:"uppercase"}}>Stuur naar een vriend</div>
                <br/>
                <br/>
            </div>
        </div>
    );
}

export default News;